"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scopeMappings = void 0;

var _services = require("./services");

var _scopes = require("./scopes");

var _userActions = require("./userActions");

var _scopeMappings;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var scopeMappings = (_scopeMappings = {}, _defineProperty(_scopeMappings, _userActions.userActions.SUMMARY.VIEW, {
  description: "Access to the Business Summary which comprises of Analytics (Transactions, Settlements, Refunds). If the user doesn’t have this permission, she can NOT view any analytics; doesn’t matter if she has individual settlement, transactions, refunds permissions.",
  servicesInvolved: [_services.services.transactions, _services.services.treasury, _services.services.commonOnboarding],
  requiredScopes: [_scopes.scopes.view_transaction_summary, _scopes.scopes.view_treasury_summary]
}), _defineProperty(_scopeMappings, _userActions.userActions.TRANSACTION.VIEW, {
  description: "User can view the transaction grid, transaction detail page for each transaction",
  servicesInvolved: [_services.services.transactions],
  requiredScopes: [_scopes.scopes.read_transactions]
}), _defineProperty(_scopeMappings, _userActions.userActions.TRANSACTION.DOWNLOAD, {
  description: "User can download the Transaction Report (both from the Transactions tab and Reports section) as well as view Transactions",
  servicesInvolved: [_services.services.transactions],
  requiredScopes: [_scopes.scopes.download_transaction_reports, _scopes.scopes.read_transactions]
}), _defineProperty(_scopeMappings, _userActions.userActions.TRANSACTIONS_OFFERS.DOWNLOAD, {
  description: "User can download the Transaction Report (both from the Transactions tab and Reports section) as well as view Transactions",
  servicesInvolved: [_services.services.offers],
  requiredScopes: [_scopes.scopes.manage_offers]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTLEMENT.VIEW, {
  description: "User can view the settlement grid, settlement detail page for each settlement",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.read_settlements, _scopes.scopes.read_tdr]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTLEMENT.DOWNLOAD, {
  description: "User can download the Settlement Report (both from the Settlements tab and Reports section) as well as view Settlements",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.download_settlement_reports, _scopes.scopes.read_settlements]
}), _defineProperty(_scopeMappings, _userActions.userActions.ON_HOLD_SETTLEMENT.VIEW, {
  description: "User can view the on hold settlement grid, settlement detail page for each settlement",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.read_settlements, _scopes.scopes.read_tdr]
}), _defineProperty(_scopeMappings, _userActions.userActions.ON_HOLD_SETTLEMENT.DOWNLOAD, {
  description: "User can download the on hold Settlement Report (both from the Settlements tab and Reports section) as well as view Settlements",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.download_settlement_reports, _scopes.scopes.read_settlements]
}), _defineProperty(_scopeMappings, _userActions.userActions.REFUND.VIEW, {
  description: "User can view the Refunds tab in the Transactions section",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.read_refunds]
}), _defineProperty(_scopeMappings, _userActions.userActions.REFUND.PROCESS, {
  description: "User can process a refund on a particular transaction; as well as read transactions and refunds.",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.process_refunds, _scopes.scopes.read_transactions, _scopes.scopes.read_refunds]
}), _defineProperty(_scopeMappings, _userActions.userActions.REFUND.DOWNLOAD, {
  description: "User can download the Refunds Report (both from the Refunds tab and Reports section) as well as view refunds",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.download_refund_reports, _scopes.scopes.read_refunds]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYMENT_GATEWAY.KEY_SALT, {
  description: "User can access the Key/Salt for integration purposes",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.manage_credentials]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYMENT_LINKS_LIST.VIEW, {
  description: "User can view Payment Links product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.read_payment_links]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYMENT_LINKS_LIST.MANAGE, {
  description: "User can access Payment Links product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.create_payment_links, _scopes.scopes.read_payment_links, _scopes.scopes.update_payment_links, _scopes.scopes.delete_payment_links]
}), _defineProperty(_scopeMappings, _userActions.userActions.BUTTON.VIEW, {
  description: "User can view Buttons product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.read_buttons]
}), _defineProperty(_scopeMappings, _userActions.userActions.BUTTON.MANAGE, {
  description: "User can access Buttons product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.create_buttons, _scopes.scopes.read_buttons, _scopes.scopes.update_buttons, _scopes.scopes.delete_buttons]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYMENT_HANDLE.VIEW, {
  description: "User can view Share Payment Handle product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.read_payment_handles]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYMENT_HANDLE.MANAGE, {
  description: "User can access Share Payment Handle product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.create_payment_handles, _scopes.scopes.read_payment_handles, _scopes.scopes.update_payment_handles, _scopes.scopes.delete_payment_handles]
}), _defineProperty(_scopeMappings, _userActions.userActions.INVOICES.VIEW, {
  description: "User can view Invoices product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.read_invoices]
}), _defineProperty(_scopeMappings, _userActions.userActions.INVOICES.MANAGE, {
  description: "User can manage Invoices product on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.create_invoices, _scopes.scopes.read_invoices, _scopes.scopes.update_invoices, _scopes.scopes.delete_invoices]
}), _defineProperty(_scopeMappings, _userActions.userActions.INVOICES.CREATE_CUSTOMER, {
  description: "User can create Invoices customer on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.create_invoice_customer]
}), _defineProperty(_scopeMappings, _userActions.userActions.INVOICES.CREATE_ITEM, {
  description: "User can create Invoices item on the Dashboard",
  servicesInvolved: [_services.services.tools],
  requiredScopes: [_scopes.scopes.create_invoice_item]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYOUT.MAKER, {
  description: "User can create a Payout",
  servicesInvolved: [_services.services.payouts],
  requiredScopes: [_scopes.scopes.maker]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYOUT.CHECKER, {
  description: "User can approve a Payout",
  servicesInvolved: [_services.services.payouts],
  requiredScopes: [_scopes.scopes.checker]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYOUT.MANAGE, {
  description: "User can create maker, checker as well as create and approve a payout",
  servicesInvolved: [_services.services.payouts],
  requiredScopes: [_scopes.scopes.manage_approval_flow]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYOUT.DOWNLOAD, {
  description: "User can create payout related reports",
  servicesInvolved: [_services.services.payouts],
  requiredScopes: [_scopes.scopes.create_payout_transactions]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYOUT.DOWNLOAD_INVOICE, {
  description: "User can download payout related invoice",
  servicesInvolved: [_services.services.payouts],
  requiredScopes: [_scopes.scopes.download_invoice_payout]
}), _defineProperty(_scopeMappings, _userActions.userActions.PAYOUT.ANY, {
  description: "User can access payouts from left side menu",
  servicesInvolved: [_services.services.payouts],
  matchAny: true,
  requiredScopes: [_scopes.scopes.maker, _scopes.scopes.checker, _scopes.scopes.manage_approval_flow, _scopes.scopes.create_payout_transactions, _scopes.scopes.download_invoice_payout, _scopes.scopes.view_beneficiary_nb, _scopes.scopes.download_beneficiary_nb, _scopes.scopes.create_beneficiary_nb, _scopes.scopes.update_beneficiary_nb, _scopes.scopes.enable_beneficiary_nb, _scopes.scopes.disable_beneficiary_nb]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTINGS.MANAGE_PROFILE, {
  description: "User can update the profile of the Business; provides access to Common Onboarding",
  servicesInvolved: [_services.services.commonOnboarding],
  requiredScopes: [_scopes.scopes.user_profile, _scopes.scopes.update_user_profile]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTINGS.MANAGE_NOTIFICATIONS, {
  description: "User can update the notifications email to be sent to users",
  servicesInvolved: [_services.services.transactions, _services.services.treasury, _services.services.commonOnboarding],
  requiredScopes: [_scopes.scopes.manage_payment_notifications, _scopes.scopes.manage_treasury_notifications]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTINGS.MANAGE_WEBHOOKS, {
  description: "User can configure webhooks on specific URLs",
  servicesInvolved: [_services.services.payouts, _services.services.transactions],
  requiredScopes: [_scopes.scopes.manage_webhooks]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTINGS.MANAGE_CHECKOUT, {
  description: "User can update brand logo, color and signature to be consumed by Checkout and Payment products",
  servicesInvolved: [_services.services.transactions, _services.services.tools],
  requiredScopes: [_scopes.scopes.manage_checkouts]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTINGS.MANAGE_TEAM_ACCOUNTS, {
  description: "User can create employees and assign roles to them",
  servicesInvolved: [_services.services.commonOnboarding],
  requiredScopes: [_scopes.scopes.manage_employees]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTINGS.MANAGE_OUTLETS, {
  description: "User can create employees and assign outlets to them",
  servicesInvolved: [_services.services.commonOnboarding, _services.services.transactions],
  requiredScopes: [_scopes.scopes.manage_outlets]
}), _defineProperty(_scopeMappings, _userActions.userActions.CHARGEBACK, {
  description: "User can access the Bank Portal (maintained by Optimus)",
  servicesInvolved: [_services.services.chargeback],
  requiredScopes: [_scopes.scopes.manage_chargebacks]
}), _defineProperty(_scopeMappings, _userActions.userActions.REPORTS_LIST.ACCESS, {
  description: "User can view reports list",
  servicesInvolved: [_services.services.treasury, _services.services.payouts, _services.services.transactions, _services.services.tools],
  matchAny: true,
  requiredScopes: [_scopes.scopes.download_refund_reports, _scopes.scopes.download_settlement_reports, _scopes.scopes.download_transaction_reports, _scopes.scopes.read_tdr, _scopes.scopes.read_payment_links, _scopes.scopes.read_buttons, _scopes.scopes.create_payout_transactions, _scopes.scopes.read_invoices]
}), _defineProperty(_scopeMappings, _userActions.userActions.NEO_BANKING.ACCESS, {
  description: "User can access NeoBanking",
  servicesInvolved: [_services.services.neobanking],
  requiredScopes: [_scopes.scopes.read_account_request_nb, _scopes.scopes.create_account_request_nb, _scopes.scopes.read_account_details_nb, _scopes.scopes.read_transaction_nb, _scopes.scopes.add_transaction_meta_data_nb, _scopes.scopes.download_transaction_nb, _scopes.scopes.read_summary_nb]
}), _defineProperty(_scopeMappings, _userActions.userActions.NEO_MARKETPLACE.ACCESS, {
  description: "User can access the NeoMarketplace",
  servicesInvolved: [_services.services.neomarketplace],
  requiredScopes: [_scopes.scopes.read_account_nmp, _scopes.scopes.read_sales_list_nmp, _scopes.scopes.read_sales_summary_nmp, _scopes.scopes.read_sales_detail_nmp, _scopes.scopes.read_settlement_list_nmp, _scopes.scopes.read_settlement_sumary_nmp, _scopes.scopes.read_settlement_details_nmp, _scopes.scopes.read_dispute_list_nmp, _scopes.scopes.read_dispute_summary_nmp, _scopes.scopes.read_dispute_details_nmp, _scopes.scopes.update_dispute_status_nmp, _scopes.scopes.register_account_nmp]
}), _defineProperty(_scopeMappings, _userActions.userActions.ACCOUNT_PAYABLES.OWNER, {
  description: "User can access the Account Payables as Owner",
  servicesInvolved: [_services.services.accountpayables],
  requiredScopes: [_scopes.scopes.write_bill_payment_nb, _scopes.scopes.read_bill_nb, _scopes.scopes.read_bill_note_nb, _scopes.scopes.read_vendor_nb, _scopes.scopes.read_bill_payment_nb, _scopes.scopes.write_bill_nb, _scopes.scopes.write_bill_note_nb, _scopes.scopes.write_vendor_nb]
}), _defineProperty(_scopeMappings, _userActions.userActions.ACCOUNT_PAYABLES.ACCOUNTANT, {
  description: "User can access the Account Payables as Accountant",
  servicesInvolved: [_services.services.accountpayables],
  requiredScopes: [_scopes.scopes.read_bill_nb, _scopes.scopes.read_bill_note_nb, _scopes.scopes.read_vendor_nb, _scopes.scopes.read_bill_payment_nb, _scopes.scopes.write_bill_nb, _scopes.scopes.write_bill_note_nb, _scopes.scopes.write_vendor_nb]
}), _defineProperty(_scopeMappings, _userActions.userActions.NEO_ONBOARDING.MANAGE, {
  description: "Check the nbStatus for elegible users",
  servicesInvolved: [_services.services.alternateOnboarding],
  requiredScopes: [_scopes.scopes.read_account_request_nb]
}), _defineProperty(_scopeMappings, _userActions.userActions.NEO_LENDING.ACCESS, {
  description: "User can access NeoLending",
  servicesInvolved: [_services.services.neolending],
  requiredScopes: [_scopes.scopes.read_credits_nb, _scopes.scopes.download_credits_nb, _scopes.scopes.download_lending_document_nb, _scopes.scopes.write_credits_nb, _scopes.scopes.prepay_credits_nb, _scopes.scopes.merchant_info_nb]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTLEMENT_CYCLE.VIEW, {
  description: "User can read Settlement Cycle related widgets",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.read_settlement_cycle]
}), _defineProperty(_scopeMappings, _userActions.userActions.SETTLEMENT_CYCLE.UPDATE, {
  description: "User can change Settlement Cycle related widgets",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.update_settlement_cycle]
}), _defineProperty(_scopeMappings, _userActions.userActions.AGGREGATOR.RELEASE_SETTLEMENT, {
  description: "Parent Aggregator Merchant can release settlements",
  servicesInvolved: [_services.services.treasury],
  requiredScopes: [_scopes.scopes.release_settlement]
}), _defineProperty(_scopeMappings, _userActions.userActions.ON_HOLD_SETTLEMENT.UPDATE, {
  description: "Parent Merchant can update settlements data",
  servicesInvolved: [_services.services.transactions, _services.services.treasury],
  requiredScopes: [_scopes.scopes.update_amlock_txn_details]
}), _scopeMappings);
exports.scopeMappings = scopeMappings;